var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'btn-group': _vm.buttons,
    'btn-group-justified': _vm.justified,
    'btn-group-vertical': _vm.vertical,
  },attrs:{"data-toggle":_vm.buttons && 'buttons'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }